import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 * Use the raw response from the http repository to create a Vehicle Certification Value Object.
 */
export class FromAdDetailsRawDataToVehicleCertificationValueObjectMapper extends Mapper {
  constructor({config, fromVehicleCertificationRawDataToVehicleCertificationVOMapper}) {
    super()

    this._config = config
    this._fromVehicleCertificationRawDataToVehicleCertificationVOMapper =
      fromVehicleCertificationRawDataToVehicleCertificationVOMapper
  }

  map = async rawData => {
    const {certification = {}} = rawData

    const {
      certificatedProgramId: certificationProgramId,
      features: certificationFeatures = [],
      logoUrl: certificationLogoUrl,
      make: certificationMake
    } = certification

    const certificationVO = this._fromVehicleCertificationRawDataToVehicleCertificationVOMapper
      .setCertificatedProgramId({
        certificatedProgramId: certificationProgramId
      })
      .setFeatures({features: certificationFeatures})
      .setLogoUrl({logoUrl: certificationLogoUrl})
      .setMake({make: certificationMake})
      .map()

    return certificationVO
  }
}
